module.exports = __webpack_public_path__ + "img/help-black-24-dp.11c16f8c.svg";